import React from 'react';


export type FollowUpSchedulerContextValue = {
  onOpen: (suggestedDate: string) => void;
  onOpenSessionDetails: (suggestedDate: string) => void;
  onSuggestedDateChange: (suggestedDate: string | null) => void;
  scheduledFollowUpDate?: string | null;
};


// The scheduler lives in `@uplift/video-call`, which already depends on this
// library, so it is passed in rather than imported here.
const FollowUpSchedulerContext = React.createContext<FollowUpSchedulerContextValue | null>(null);


export const FollowUpSchedulerProvider: React.FC<FollowUpSchedulerContextValue> = ({ onOpen, onOpenSessionDetails, onSuggestedDateChange, scheduledFollowUpDate, children }) => {
  const value = React.useMemo(() => ({
    onOpen: onOpen,
    onOpenSessionDetails: onOpenSessionDetails,
    onSuggestedDateChange: onSuggestedDateChange,
    scheduledFollowUpDate: scheduledFollowUpDate,
  }), [ onOpen, onOpenSessionDetails, onSuggestedDateChange, scheduledFollowUpDate ]);

  return (
    <FollowUpSchedulerContext.Provider value={value}>
      {children}
    </FollowUpSchedulerContext.Provider>
  );
};


export const useFollowUpScheduler = () => {
  return React.useContext(FollowUpSchedulerContext);
};
